const carousel = document.querySelector('#js-autoscroll');
const maxWidth = carousel.scrollWidth / 2;
let carouselScroll = 0;

if (document.body.clientWidth >= 750) {
  window.setInterval(() => {
    if (carouselScroll > maxWidth) {
      carouselScroll = 0;
    } else {
      carousel.style.transform = `translateX(${-carouselScroll}px)`;
      carouselScroll += 1;
    }
  }, 30);
}
